import React from 'react'

// ArComponents
import ArCompanyStory from 'src/components/ArCompanyStory/ArCompanyStory'
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArCTASection from 'src/components/ArCTASection/ArCTASection'
import ArCompanyTeam from 'src/components/ArCompanyTeam/ArCompanyTeam'
import ArTextWithImageHalvedOnTablet from 'src/components/ArTextWithImageHalvedOnTablet/ArTextWithImageHalvedOnTablet'
import ArSeo from 'src/components/ArSeo/ArSeo'

// Data
import DaPageCompanyAbout from 'src/data/PageCompanyAbout'
import DaDataCommon from 'src/data/DataCommon'
import routesConfig from 'src/routes.config'

class AboutPage extends React.Component {
  render () {
    return (
      <React.Fragment>
        <ArSeo
          title={DaPageCompanyAbout.metadata.title}
          description={DaPageCompanyAbout.metadata.desc}
          path={routesConfig.company.about()}
        />

        {(() => {
          const { image, title } = DaPageCompanyAbout.ArHeroHeader
          return (
            <ArHeroHeader
              variant="company-about"
              image={image}
              title={title}
            />
          )
        })()}

        {(() => {
          const { items } = DaPageCompanyAbout.ArTextWithImageHalvedOnTablet

          return items.map(({ title, description, image, cta, ...scRest }, index) =>
            <ArTextWithImageHalvedOnTablet
              key={index}
              title={title}
              description={description}
              image={image}
              cta={cta}
              scImageToRight={!((index + 1) % 2)}
              scHideMobileImg={true}
              { ...scRest }
            />
          )
        })()}

        {(() => {
          const { title, items } = DaPageCompanyAbout.ArCompanyStory

          return (
            <ArCompanyStory title={title} items={items} />
          )
        })()}

        {(() => {
          const { title, description, team } = DaPageCompanyAbout.ArCompanyTeam

          return (
            <ArCompanyTeam title={title} description={description} team={team} />
          )
        })()}

        {/* Removed by bugherd task #68
          {(() => {
            const { title, partners } = DaPageCompanyAbout.ArPartnersWithImage

            return (
              <ArPartnersWithImage title={title} partners={partners} />
            )
          })()}
        */}

        {(() => {
          const { title, cta, backgroundColor } = DaDataCommon.ArCTASection

          return (
            <ArCTASection title={title} cta={cta} scBackgroundColor={backgroundColor} />
          )
        })()}

      </React.Fragment>
    )
  }
}

export default AboutPage
